import React from 'react'

import { GameWithUserInformation } from '../../../containers/GamesBlock/types'
import FreeRoundsIcon from './FreeRoundsIcon'
import TournamentsIcon from './TournamentsIcon'
import UnfinishedIcon from './UnfinishedIcon'

interface Props {
  game: GameWithUserInformation
}
export default function Icons({ game }: Props) {
  const { isUnfinished } = game
  const { hasFreeRounds } = game
  const { isInTournament } = game

  return (
    <>
      <UnfinishedIcon condition={isUnfinished} />
      <FreeRoundsIcon condition={hasFreeRounds} />
      <TournamentsIcon condition={isInTournament && !hasFreeRounds} />
    </>
  )
}
